/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const CreateOpportunityTimelineItemInputJsonApiModel = {
  id: "",
  "opportunity-timeline-section": {
    jsonApi: "hasOne",
    type: "opportunity-timeline-items",
  },
};
